export default "__VITE_ASSET__lkt$89tc__"